import { getPlanSubscriptions } from '../../../api/planSubscriptionApi'
import PlanSubscriptionSearchFilter from '../../../components/plan-subscriptions/plan-subscription-filter/plan-subscription-filter'
import PlanSubscriptionsList from '../../../components/plan-subscriptions/plan-subscriptions-list/plan-subscriptions-list'
import { getSearchParams, getSearchValues } from '../../../helpers/utils'
import { PageInfo } from '../../../share-types'
import {
  IPlanSubscription,
  IPlanSubscriptionFilterParams,
  PlanSubscriptionFilter,
} from '../share-type'
import { Card, Space } from 'antd'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

const defaultPageInfo: PageInfo = { currentPage: 1, pageSize: 10, count: 0 }

const PlanSubscriptions = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [subscriptions, setSubscriptions] = useState<IPlanSubscription[]>([])
  const [pageInfo, setPageInfo] = useState<PageInfo>(defaultPageInfo)
  const [searchValues, setSearchValues] = useState<IPlanSubscriptionFilterParams>()

  const loadPlanSubscriptions = (params: PlanSubscriptionFilter) => {
    getPlanSubscriptions(params).then(response => {
      setSubscriptions(response.data)
      setPageInfo({ ...response.pageInfo, currentPage: response.pageInfo.currentPage + 1 })
    })
  }

  useEffect(() => {
    const values = getSearchValues(
      [
        { key: 'id', isBoolean: false },
        { key: 'userId', isBoolean: false },
        { key: 'planId', isBoolean: false },
        { key: 'status', isBoolean: false },
        { key: 'autoRenewStatus', isBoolean: false },
        { key: 'currentPeriodEndsAtFrom', isBoolean: false },
        { key: 'currentPeriodEndsAtTo', isBoolean: false },
        { key: 'size', isBoolean: false, default: defaultPageInfo.pageSize },
        { key: 'page', isBoolean: false, default: defaultPageInfo.currentPage - 1 },
      ],
      searchParams,
    )
    const data: PlanSubscriptionFilter = {
      ...values,
      id: values.id ? Number(values.id) : undefined,
      userId: values.userId ? Number(values.userId) : undefined,
      planId: values.planId ? Number(values.planId) : undefined,
      page: Number(values.page),
      size: Number(values.size),
    }
    setSearchValues(data)
    loadPlanSubscriptions(data)
  }, [])

  const onPaginationChange = (page: number, pageSize: number) => {
    const data: PlanSubscriptionFilter = { ...searchValues, page: page - 1, size: pageSize }
    setSearchParams(getSearchParams(data))
    loadPlanSubscriptions(data)
  }

  const onSearch = (value: IPlanSubscriptionFilterParams) => {
    const data: PlanSubscriptionFilter = { ...value, page: 0, size: pageInfo.pageSize }
    setSearchValues(value)
    setSearchParams(getSearchParams(data))
    loadPlanSubscriptions(data)
  }

  return (
    <Card>
      <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
        <PlanSubscriptionSearchFilter formData={searchValues} onSearch={onSearch} />
        <PlanSubscriptionsList
          subscriptions={subscriptions}
          pagination={{
            current: pageInfo.currentPage,
            pageSize: pageInfo.pageSize,
            total: pageInfo.count,
            showSizeChanger: true,
          }}
          onPaginationChange={onPaginationChange}
        />
      </Space>
    </Card>
  )
}

export default PlanSubscriptions
